export default "__VITE_ASSET__DQQXJ4JF__"